module.exports = "xyz";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates/~/xyz.js
 ** module id = 13
 ** module chunks = 0
 **/